<template>
  <container :class="['icons']" v-if="icons">
    <container v-for="(icons, provider) in icons" v-if="getProvider(provider)" :key="provider">
      <h-three :title="$lang.providerIcons(getProvider(provider).name, icons.length)" />
      <card>
        <card-text max-height="170px" padding-off>
          <ul :class="['inline-list', 'barebone-list']">
            <li v-for="icon in icons" :key="icon" :class="['text-center']">
              <div :class="['p-1', 'cursor-pointer']" :title="$lang.clickToCopy" @click="copyToClipboard(getIconName(icon, provider))">
                <icon :size="2" :name="getIconName(icon, provider)" :class="['my-3']" :provider="getProvider(provider).prefix" />
                <code-chunk :class="['truncate']">{{ getIconName(icon, provider) }}</code-chunk>
              </div>
            </li>
          </ul>
        </card-text>
      </card>
    </container>
    <snackbar v-model="snackbar" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness">{{ $lang.copiedToClipboard(copiedValue) }}</snackbar>
  </container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'Icons',
  mixins: [
    methods
  ],
  data () {
    return {
      icons: null,
      snackbar: false,
      copiedValue: null,
      providers: {
        'material.io': {
          name: 'Google Icons',
          prefix: 'google'
        },
        'materialdesignicons.com': {
          name: 'Material Design Icons',
          prefix: 'mdi'
        },
        'fontawesome.com': {
          name: 'Font Awesome',
          prefix: 'fa'
        }
      }
    }
  },
  mounted () {
    this.getIcons()
  },
  methods: {
    getIconName (icon, provider) {
      return icon.replace(this.getProvider(provider).prefix + '-', '')
    },
    getProvider (provider) {
      return this.providers[provider]
    },
    getIcons () {
      this.$http({
        url: `${this.$root.config.staticAssetsDir}/data/miscellaneous/icons.json`
      }).then(response => {
        if (response.status === 200 && response.data) {
          this.icons = response.data.icons
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
<style>
.icons li
{
  width: 20%;
}

@media (max-width: 768px) {
  .icons li
  {
    width: 33.3333333333%;
  }
}

@media (max-width: 480px) {
  .icons li
  {
    width: 50%;
  }
}

@media (max-width: 360px) {
  .icons li
  {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/icons.vue